







































import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import Gallery from '../components/gallery/gallery.component.vue';
import { Camera } from '@/models/camera';
import { Project } from '@/models/project';
import { User } from '@/models/user';

@Component({
  components: {
    Gallery,
  },
})
export default class CameraGalleryList extends Vue {
  @Prop({ required: true }) readonly project!: Project;
  @Prop({ required: true }) readonly isPremium!: boolean;
  @Prop({ required: true }) readonly guest!: boolean;
  @Prop({ required: true }) readonly user!: User;
  @Prop({ type: Boolean, default: false }) readonly syncGalleries!: boolean;
  @State('premium', { namespace: 'project' }) readonly ownerPremium!: boolean;

  cameras: Camera[] = [];
  newPhotoAvailable = false;
  isSwitchEnabled = true;
  private galleryComparaison: string | null = null;

  mounted() {
    this.loadCameras();
  }

  loadCameras() {
    if (this.project && this.project.cameras) {
      console.log('Cameras:', this.project.cameras);
      this.cameras = this.project.cameras;
    }
  }

  refreshPhoto(cameraId: string) {
    console.log(`Refreshing photos for camera ID: ${cameraId}`);
    // Ajoutez la logique pour rafraîchir les photos pour une caméra spécifique
  }

  isLastOdd(index: number): boolean {
    return this.cameras.length % 2 !== 0 && index === this.cameras.length - 1;
  }

  onPhotoChanged(date: Date, sourceCameraId: string) {
    // Vérifiez si le switch est activé
    if (!this.syncGalleries) {
      console.log('Sync is disabled. Skipping onPhotoChanged.');
      return;
    }

    console.log('onPhotoChanged triggered with date:', date, 'from cameraId:', sourceCameraId);
    this.$nextTick(() => {
      this.cameras.forEach((cam) => {
        if (cam.id !== sourceCameraId) {
          const refName = 'gallery-' + cam.id;
          const galleryRef = this.$refs[refName];

          console.log('Attempting to call goToClosestPhoto on:', cam.id, galleryRef);

          let galleryInstance: (Vue & { goToClosestPhoto: (d: Date) => void }) | undefined;

          if (Array.isArray(galleryRef)) {
            galleryInstance = galleryRef[0] as Vue & { goToClosestPhoto: (d: Date) => void };
          } else {
            galleryInstance = galleryRef as Vue & { goToClosestPhoto: (d: Date) => void };
          }

          if (galleryInstance && typeof galleryInstance.goToClosestPhoto === 'function') {
            galleryInstance.goToClosestPhoto(date);
          } else {
            console.warn('galleryRef or goToClosestPhoto not found for camera', cam.id);
          }
        }
      });
    });
  }

  galleryKey(cameraId: string): string {
    // Générer une clé unique basée sur l'ID de la caméra et un timestamp ou une version de l'image
    return `${cameraId}-${Date.now()}`;
  }
}
